import mutations from './mutations';
import actions from './actions';

const state = {
  errorModal: null,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
